import { useCallback } from 'react';
import { useAtomValue } from 'jotai';

import { structureRelationship } from '@/components/Analysis/state';

export function usePointCloudClick() {
  const structureRelationships = useAtomValue(structureRelationship);

  const annotation3dToAssemblyId = useCallback(
    (annotation3d: number) => {
      const annotationId = structureRelationships?.annotation3dToAnnotationId[annotation3d];

      if (!annotationId) return;

      const assemblyId = structureRelationships?.annotationIdToAssemblyId[annotationId];

      return assemblyId;
    },
    [structureRelationships]
  );

  return { annotation3dToAssemblyId };
}
